import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {  Observable } from "rxjs";
import { CookieService } from "ngx-cookie-service";
import { Suscripcion } from "../models/suscripcion";
import { global } from "../global";
@Injectable({
  providedIn: "root",
})
export class SuscripcionesService {
  eliminarSuscripcionBroker(suscripcion: Suscripcion) : Observable<any>{
    return this.http.post(`${this.apiUrl}/eliminarSuscripcionBroker`, suscripcion, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
    });
  }
  enviarAuto(suscripcion: Suscripcion) : Observable<any>{
    return this.http.post(`${this.apiUrl}/enviarAuto`, suscripcion, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
    });
  }
  eliminarSuscripcionGestor(suscripcion: Suscripcion) : Observable<any>{
    return this.http.post(`${this.apiUrl}/eliminarSuscripcionGestor`, suscripcion, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
    });
  }
  apiUrl: string = "";
  timezoneoffset: Number = 0;

  get licencia(): string {
    return this.cookieService.get("auth_token");
  }

  constructor(private http: HttpClient, private cookieService: CookieService) {
    this.apiUrl = global.url + "suscripciones";
    this.timezoneoffset = new Date().getTimezoneOffset();
  }

  listarSuscripciones(): Observable<any> {
    return this.http.post(
      `${this.apiUrl}/listarSuscripciones`,
      {},
      {
        headers: {
          licencia: this.licencia, timezoneoffset:this.timezoneoffset.toString(),
          "Content-Type": "application/json",
        },
      }
    );
  }
  listarSuscripcionesConfirmar(idcartera: string): Observable<any> {
    return this.http.post(
      `${this.apiUrl}/listarSuscripciones`,
      {},
      {
        headers: {
          licencia: this.licencia, timezoneoffset:this.timezoneoffset.toString(),
          "Content-Type": "application/json",
        },
      }
    );
  }

  buscarTop10ByidUsuario(idUsuario: number): Observable<any> {
    let params = new HttpParams().set("idUsuario", String(idUsuario));
    return this.http.get(`${this.apiUrl}/buscarTop10ByidUsuario`, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
      params: params,
    });
  }

  registrarSuscripcion(suscripcion: Suscripcion): Observable<any> {
    return this.http.post(`${this.apiUrl}/registrarSuscripcion`, suscripcion, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
    });
  }

  registrarSuscripcionAuto(suscripcion: Suscripcion): Observable<any> {
    return this.http.post(`${this.apiUrl}/registrarSuscripcionAuto`, suscripcion, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
    });
  }
  registrarAuto(suscripcion: Suscripcion): Observable<any> {
    return this.http.post(`${this.apiUrl}/registrarAuto`, suscripcion, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
    });
  }
  eliminarSuscripcion(idSuscripcion: number): Observable<any> {
    return this.http.delete(
      `${this.apiUrl}/eliminarSuscripcion/${idSuscripcion}`,
      {
        headers: {
          licencia: this.licencia,
          "Content-Type": "application/json",
        },
      }
    );
  }

  eliminarSuscripcionAuto(idSuscripcion: number): Observable<any> {
    return this.http.delete(
      `${this.apiUrl}/eliminarSuscripcionAuto/${idSuscripcion}`,
      {
        headers: {
          licencia: this.licencia,
          "Content-Type": "application/json",
        },
      }
    );
  }
}
